<template>
  <div class="ueditor-container" style="position: relative">
    <i class="insertImgx" @click="onPic"></i>
    <i class="insertVideox" @click="onVideo"></i>
    <div v-show="checked" :id="editorId" class="ueditor-content"></div>
  </div>
</template>
<script>
export default {
  name: "uEditorTool",
  props: {
    content: "",
    checked: false,
    name: "",
  },
  data() {
    return {
      fullscreen: false,
      ueditor: null,
    };
  },
  computed: {
    editorId() {
      return `uedittor_id_${this.name || new Date().valueOf()}`;
    },
    html() {
      return this.ueditor ? this.ueditor.getContent() : "";
    },
  },
  watch: {
    content: {
      handler(n) {
        this.setUeditor(n);
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    setUeditor(html) {
      clearTimeout(this.time);
      this.time = setTimeout(() => {
        this.fullscreen = false;

        const options = {
          lang: "zh-cn",
          initialFrameWidth: null,
          autoHeightEnabled: false,
        };
        const ue = UE.getEditor(this.editorId, options);
        this.ueditor = ue;
        ue.ready(function () {
          ue.setHeight(500);
          ue.setContent(html);
        });
      }, 200);
    },
    onPic() {
      this.$emit("pic", this.ueditor);
    },
    onVideo() {
      this.$emit("video", this.ueditor);
    },
    insertHtml(html) {
      this.ueditor.execCommand("insertHtml", html);
    },
    insertImage(option = {}) {
      this.ueditor.execCommand("insertimage", option);
    },
    insertVideo(option = {}) {
      this.ueditor.execCommand("insertvideo", option);
    },
  },
};
</script>
<style scoped>
::v-deep .edui-default .edui-for-nimages .edui-icon {
  background-position: -726px -77px;
}
::v-deep .edui-default .edui-for-nvideo .edui-icon {
  background-position: -320px -20px;
}
::v-deep .edui-default.edui-toolbar {
  line-height: normal !important;
}
.ueditor-container {
  width: 1067px;
  position: relative;
}
.ueditor-container .insertImgx {
  position: absolute;
  top: 30px;
  right: 660px;
  z-index: 1000;
  width: 20px;
  height: 20px;
}

.ueditor-container .insertVideox {
  position: absolute;
  top: 30px;
  right: 634px;
  z-index: 1000;
  width: 20px;
  height: 20px;
}

.ueditor-content {
  position: relative;
  margin-bottom: 8px;
  margin-top: 4px;
}
</style>
